export default __webpack_public_path__ + "media/images/app-icon-62238d0dc429f8937d9fee3c7bf829cd.svg";